import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import PostingsApi from '../../../../API/shipment/postings-api';
import { Column, NavTabs, Row, WhiteBlock } from '../../../../components/Basic/Blocks';
import { DateInput, Input, InputLabel, Select } from '../../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableHeader } from '../../../../components/Basic/Table';
import { Text } from '../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../constans';
import { MARKETS_LIST } from '../../../Shipments/Shipment';
import ReviewsLine from './Line';
import styles from './styles.module.scss';

export const WIDTH_POSTING = [
  '150px', // 0
  '400px', // 1
  '200px', // 2
  '200px', // 3
  '180px', // 4
  '127px', // 5
  '100px', // 6
  '200px', // 7
  '100px', // 8
  '40px', // 9
  '100px', // 10
  '250px', // 11
  '170px', // 12
  '140px', // 13
  '500px', // 14
  '60px', // 15
];

let RATING_MAP = {
  'Не выбран': undefined,
  '1 звезда': 1,
  '2 звезды': 2,
  '3 звезды': 3,
  '4 звезды': 4,
  '5 звезд': 5,
};
let COMMENT_MAP = {
  'Не выбран': undefined,
  'C комментарием': true,
  'Без комментариев': false,
};
const FILTER_MARKETPLACE = {
  0: 'check_reviews_all',
  1: 'check_reviews_new',
  2: 'check_reviews_processing',
  3: 'check_reviews_archive',
};
const MODES = ['Режим отгрузки', 'Режим докупов', 'Честный знак'];

const MODES_OWNER = ['Режим отгрузки', 'Режим докупов', 'Честный знак', 'Финансы', 'Режим упаковки'];

const SHOPS = {
  ozon: ['Все', 'ozon1', 'ozon2', 'ozon3', 'ozon4', 'ozon5', 'ozon6', 'ozon7'],
  yandex: ['Все', 'yandex1', 'yandex3', 'yandex4', 'yandex5', 'yandex6', 'yandex7', 'yandex8'],
  wb: ['Все', 'wb1', 'wb2', 'wb3', 'wb4', 'wb5', 'wb6', 'wb7'],
  megamarket: ['Все', 'megamarket1', 'megamarket2'],
};

const CalcMonthAgo = () => {
  const start = new Date();
  start.setTime(start.getTime() - 60 * 24 * 3600000);

  return start;
};

const CalcFeatureTwoDay = () => {
  const start = new Date();
  start.setTime(start.getTime() + 2 * 24 * 3600000);
  return start;
};

const ReviewsTable = ({ }) => {
  const [show, setShow] = useState(50);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [postings, setPostings] = useState({ ids: [], byId: {} });
  const [period, setPeriod] = useState({ start: CalcMonthAgo(), end: CalcFeatureTwoDay() });

  const [count, setCount] = useState([]);
  const [countStock, setCountStock] = useState([0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [provider, changeProvider] = useState({ providerId: '' });
  const [rating, changeRating] = useState('Не выбран');
  const [hasComment, changeHasComment] = useState('Не выбран');

  const allProviders = useSelector((store) => store.providers);
  const [checkAll, setCheckAll] = useState(false);
  const [map, setMap] = useState({});
  const [marketMany, setMarketMany] = useState(MARKETS_LIST[0]);
  const [shopName, setShopName] = useState('Все');
  const [providers, setProviders] = useState([]);

  const [openReviewType, setOpenReviewType] = useState(false);
  const [productsSelect, setProductsSelect] = useState({});

  const user = useSelector((store) => store.user);

  const isOwner = user.role === 'owner' || user.role === 'admin';
  const isAdmin = isOwner || user.role === 'user';

  const onChangePage = (v) => {
    setPage(v);
  };

  const moveToReview = () => { };

  const modes = isOwner ? MODES_OWNER : MODES;

  const clickCheckAll = (flag) => {
    if (flag) {
      const map_select = {};
      postings.ids.forEach((item) => {
        map_select[postings.byId[item].posting_number] = true;
      });
      setProductsSelect(map_select);
      setCheckAll(true);
    } else {
      setCheckAll(false);
      setProductsSelect({});
    }
  };

  const changeProductSelect = (posting_number) => {
    if (productsSelect[posting_number]) {
      const s = productsSelect;
      delete s[posting_number];
      setProductsSelect({ ...s });
    } else {
      setProductsSelect({ ...productsSelect, [posting_number]: true });
    }
  };

  const params = useMemo(() => {
    const shop_name = shopName === 'Все' ? '' : shopName;

    return {
      search: search.trim(),
      market: marketMany === 'Не выбрана' ? undefined : marketMany.toLowerCase(),
      shop: shop_name,
      providerId: provider.id,
      limit: parseInt(show),
      page,
      tab: FILTER_MARKETPLACE[tab],
      period: {
        startDate: period.start,
        endDate: period.end,
      },
      filters: {
        ratingReview: RATING_MAP[rating],
        hasCommentReview: COMMENT_MAP[hasComment],
      },
    };
  }, [search, show, page, tab, provider.id, marketMany, shopName, rating, hasComment, period]);

  const load = () => {
    PostingsApi.getCheckReviews({ data: params }).then((r) => {
      const { check_reviews_all, check_reviews_new, check_reviews_processing, check_reviews_archive } = r.all_count;

      const byIds = {};
      const id = r.postings.map((item) => item.posting_number);
      r.postings.forEach((item) => (byIds[item.posting_number] = item));

      setPostings({ byId: byIds, ids: id });
      setMap(r.cardsMap);
      setProductsSelect({});
      setCheckAll(false);
      setCountStock([check_reviews_all, check_reviews_new, check_reviews_processing, check_reviews_archive]);

      setCount(r.count);
    });

    return () => { };
  };

  const changePostings = async (postingNumbers, field, value) => {
    await PostingsApi.changePostings({
      data: {
        postingNumbers,
        field,
        value,
      }
    });
    await load();
  };

  useEffect(() => {
    load();
  }, [params]);

  const onChangeTab = (n) => {
    setTab(n);
  };

  useEffect(() => {
    const p = allProviders.filter((item) => !item.hide);
    if (p.length > 0) {
      setProviders([{ name: 'Не выбран', id: null }, ...p]);
      changeProvider({ name: 'Не выбран', id: null });
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  return (
    <>
      <WhiteBlock className={styles.search_block}>
        <Row className={styles.navigate_table}>
          <NavTabs
            open_tab={tab}
            tabs={['Все отзвывы', 'Новые', 'На проверке', 'Архив']}
            isNum={true}
            num={countStock}
            style_tab={styles.style_tab}
            onChange={onChangeTab}
          />
        </Row>

        <Row className={styles.row_input}>
          {Object.keys(productsSelect).length > 0 ? (
            <Row className={styles.row_select}>
              <Row>
                {isOwner && (
                  <Button
                    type={TYPE_BUTTONS.BLUE}
                    style={{ marginRight: '15px' }}
                    onClick={() => setOpenReviewType(true)}
                  >
                    Перенести в проверку
                  </Button>
                )}
              </Row>
            </Row>
          ) : (
            <Input value={search} onBlur={(v) => setSearch(v)} onClickEnter={(v) => setSearch(v)} label="Поиск" />
          )}
        </Row>

        <Text style={{ marginTop: '15px' }}>{`Найдено: ${count}`}</Text>

        <Row spaceBetween={true}>
          <Row style={{ height: '40px' }}>
            <div>
              <Select
                label="Показать на странице"
                select={show}
                list={['20', '50', '100', '150', '200', '500', '1000']}
                onSelect={(v) => setShow(v)}
                width="150px"
                style={{ marginRight: '15px' }}
              />
            </div>

            <Select
              list={MARKETS_LIST}
              select={marketMany}
              label="Площадка"
              onSelect={(v) => setMarketMany(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              list={SHOPS[marketMany.toLowerCase()] || []}
              select={shopName}
              disabled={marketMany === MARKETS_LIST[0]}
              label="Магазин"
              onSelect={(v) => setShopName(v)}
              width={'150px'}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Поставщик"
              select={provider}
              valueFn={(p) => p.name}
              list={providers}
              width="200px"
              onSelect={(v) => changeProvider(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Рейтинг"
              select={rating}
              list={['Не выбран', '1 звезда', '2 звезды', '3 звезды', '4 звезды', '5 звезд']}
              width="200px"
              onSelect={(v) => changeRating(v)}
              style={{ marginRight: '15px' }}
            />
            <Select
              label="Наличие комментария"
              select={hasComment}
              list={['Не выбран', 'C комментарием', 'Без комментариев']}
              width="200px"
              onSelect={(v) => changeHasComment(v)}
              style={{ marginRight: '15px' }}
            />
          </Row>
          <Row>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Начало периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.start}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                />
              </Row>
            </Column>
            <Column style={{ marginRight: '10px' }}>
              <InputLabel>Конец периода</InputLabel>
              <Row style={{ width: '130px' }}>
                <DateInput
                  value={period.end}
                  className={styles.calendar}
                  onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                />
              </Row>
            </Column>
          </Row>
        </Row>
      </WhiteBlock>
      <Table styles={styles.table}>
        <TableHeader whiteHeader>
          <HeaderTitle width={WIDTH_POSTING[9]} />
          <HeaderTitle width={WIDTH_POSTING[0]}>Номер заказа</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[1]}>Позиции в заказе</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[0]} centerText={true}>Рейтинг</HeaderTitle>
          <HeaderTitle width={WIDTH_POSTING[14]}>Отзыв покупателя</HeaderTitle>
        </TableHeader>
        {postings.ids.map((order) => {
          return (
            <ReviewsLine
              isAdmin={isAdmin}
              MODES={modes}
              tab={tab}
              order={postings.byId[order]}
              map={map}
              changePostings={changePostings}
              key={postings.byId[order].posting_number}
              postingsSelect={productsSelect}
              selectPosting={changeProductSelect}
            />
          );
        })}
      </Table>
      {openReviewType && (
        <AddToCheckupsPopUp
          clickOk={() => { }}
          reason_type="Отзыв"
          close={() => setOpenReviewType(false)}
          postings={Object.keys(productsSelect)}
        />
      )}
    </>
  );
};

export default ReviewsTable;
